
const digest = '414016ef01222e9b0e0923efa2c58afe4886548b9d5b702ab52b354064077b94';
const classes = {"wrapper":"_wrapper_hsvu0_1","list":"_list_hsvu0_1"};
const css = `._wrapper_hsvu0_1 ._list_hsvu0_1 {
  margin-top: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  